// extracted by mini-css-extract-plugin
export default {"pre__loader":"PreLoader_pre__loader__H-CkF"};